export default "__VITE_ASSET__BPpgfyH0__"